import React from 'react';
import Navbar from '../../../../examples/Navigation/Navbar.jsx'; 
import Savings from './saving.js'; 
import Footer from '../../../../examples/Footers/Footer/footer.jsx'; 
import SavingsBanner from './SavingsBanner.jsx';
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import SavingsCalculatorImage from "./savings.jpg";

const SavingsCalculator = () => {
  return (
    <div className="main-layout-container">
      <header>
        <Navbar />
      </header>
      <main>
      <MKBox
  position="relative"
  width="100%"
  height="55vh"
  display="flex"
  alignItems="center"
  justifyContent="left"
>
  {/* Background Image */}
  <img
    src={SavingsCalculatorImage}
    alt="Career Banner"
    style={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "center",
    }}
  />

<MKTypography
  variant="h1"
  component="div"
  color="white"
  sx={{
    position: "absolute",
    fontSize: { 
      md: "2.7rem",   // Font size for desktop and larger devices
    },
    fontWeight: "bold",
    mt: 8,
    textAlign: "center",
    left: "50%", // Center horizontally
    transform: "translateX(-50%)", // Adjust horizontal alignment
    textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
    "@media (max-width: 430px)": {
      fontSize: "1.9rem",  // Smaller font for screens <= 430px
    },
    "@media (max-width: 768px)": {
      fontSize: "2.2rem",  // Font size for screens between 430px and 768px
    },
  }}
>
  Maximize Efficiency, Cut Costs, and Protect the Planet
</MKTypography>



</MKBox>

        <SavingsBanner />
        <Savings />
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
};

export default SavingsCalculator;
